var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "resize",
          rawName: "v-resize",
          value: _vm.onResize,
          expression: "onResize",
        },
      ],
    },
    [
      _vm.status.loading_giftcode
        ? _c("div", { staticClass: "skeleton" }, [
            _vm._m(0),
            _c(
              "div",
              [
                _c(
                  "v-row",
                  _vm._l(6, function (i, index) {
                    return _c(
                      "v-col",
                      { key: index, attrs: { cols: "12", md: "6" } },
                      [
                        _c(
                          "div",
                          [
                            _c("v-skeleton-loader", {
                              attrs: {
                                tile: "",
                                type: "list-item-avatar-three-line",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    )
                  }),
                  1
                ),
                _c("v-skeleton-loader", {
                  attrs: { tile: "", type: "list-item" },
                }),
              ],
              1
            ),
          ])
        : _c("div", [
            _c(
              "div",
              {
                staticClass: "giftcode-news__title",
                on: {
                  click: function ($event) {
                    _vm.show = !_vm.show
                  },
                },
              },
              [
                _c("img", {
                  staticClass: "giftcode-news__icon",
                  attrs: {
                    src: require("../assets/icons/giftcard.svg"),
                    alt: "",
                    srcset: "",
                  },
                }),
                _vm._v(" Giftcode dành cho bạn "),
                _c(
                  "v-btn",
                  { staticClass: "giftcode-news__button", attrs: { icon: "" } },
                  [
                    _c("v-icon", { attrs: { color: "primary" } }, [
                      _vm._v(
                        _vm._s(_vm.show ? "mdi-chevron-up" : "mdi-chevron-down")
                      ),
                    ]),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm.giftcodes.length !== 0
              ? _c(
                  "div",
                  [
                    _c(
                      "v-expand-transition",
                      [
                        _c(
                          "v-row",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.show,
                                expression: "show",
                              },
                            ],
                          },
                          _vm._l(_vm.giftcodes, function (giftcode, index) {
                            return _c(
                              "v-col",
                              {
                                key: index,
                                attrs: { cols: "12", md: "6" },
                                on: {
                                  click: function ($event) {
                                    return _vm.goDetailPage(giftcode)
                                  },
                                },
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "giftcode-news-item" },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "giftcode-news-item__image",
                                      },
                                      [
                                        _c("img", {
                                          attrs: {
                                            src: giftcode.game_icon,
                                            alt: "",
                                            srcset: "",
                                            width: "100%",
                                          },
                                        }),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "giftcode-news-item__text d-block",
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "giftcode-news-item__title d-block",
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(giftcode.game_name) +
                                                " "
                                            ),
                                          ]
                                        ),
                                        _vm._v(
                                          " " + _vm._s(giftcode.title) + " "
                                        ),
                                        _c(
                                          "span",
                                          { staticClass: "d-block" },
                                          [
                                            _c(
                                              "v-chip",
                                              {
                                                staticClass:
                                                  "giftcode-news-item__type white--text",
                                                attrs: { color: "#e88d50" },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    giftcode.type === "facebook"
                                                      ? _vm.$t("unique")
                                                      : _vm.$t("generic")
                                                  )
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ]
                            )
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _c("div", { staticClass: "mt-4 text-center" }, [
                  _vm._v("Không có sự kiện diễn ra"),
                ]),
          ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "giftcode-news__title" }, [
      _c("img", {
        staticClass: "giftcode-news__icon",
        attrs: {
          src: require("../assets/icons/giftcard.svg"),
          alt: "",
          srcset: "",
        },
      }),
      _vm._v(" Giftcode dành cho bạn "),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }